<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="section-title-wrapper text-center section-space--mb_60 wow move-up"
          >
            <h2 class="section-title font-weight--bold mb-15">
              Frequently Asked Questions
            </h2>
          </div>
        </div>
      </div>
      <div class="faq-wrapper">
        <HAccordion :items="faqs" />
      </div>
    </div>
  </div>
</template>

<script>
import faqs from "../data/faqs";
import HAccordion from "@/components/HAccordion";

export default {
  components: { HAccordion },

  data() {
    return {
      faqs: faqs,
    };
  },
};
</script>
